<template>
  <div class="setting-team">
    <div class="toolbar">
      <div class="btns">
        <button type="button" class="btn btn-outline-black w180"
          @click="showModalAdd">+ New Team Member</button>
      </div>

      <div class="filters">
        <div class="input-search">
          <input type="text" name="s" class="form-control" placeholder="SEARCH TEAM..." v-model="keyword" @change="getUsers()">
        </div>
        <v-select v-model="ftUserType" :options="userTypes" class="ft-type" :reduce="item => item.id"
                  label="title" :searchable="false" :placeholder="'ALL TYPES'"></v-select>
      </div>
    </div>

    <div class="table-responsive">
      <table class="table table-sm table-hover">
        <thead>
          <tr>
            <th width="40"></th>
            <th width="10%"><a href="javascript:;">FIRST NAME</a></th>
            <th width="10%"><a href="javascript:;">LAST NAME</a></th>
            <th width="10%"><a href="javascript:;">TEAM</a></th>
            <th><a href="javascript:;">EMAIL</a></th>
            <th width="120"><a href="javascript:;">COST RATE</a></th>
            <th width="140"><a href="javascript:;">BILLABLE RATE</a></th>
            <th width="120"><a href="javascript:;">ACCESS LEVEL</a></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(user, index) in users" :key="index">
            <td><span class="avatar" @click="showModalEdit(index)">{{ user.initials }}</span></td>
            <td><a href="javascript:;" class="black" @click="showModalEdit(index)">{{ user.first_name }}</a></td>
            <td><a href="javascript:;" class="black" @click="showModalEdit(index)">{{ user.last_name }}</a></td>
            <td>{{ user.team?user.team.name:'' }}</td>
            <td><a :href="'mailto:' + user.email">{{ user.email }}</a></td>
            <td>${{ user.cost_rate | numberFormat }}</td>
            <td>${{ user.billable_rate | numberFormat }}</td>
            <td :class="['text-' + (user.user_type.color_class ? user.user_type.color_class : 'primary')]">{{ user.user_type.title }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="hasFilters && users.length == 0" class="alert alert-warning">
      No users found
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ServiceUser from '@/services/user'
import ModalAddMember from './ModalAddMember';
import ModalEditMember from './ModalEditMember';

export default {
  data () {
    return {
      keyword: '',
      ftUserType: '',
      users: []
    }
  },
  watch: {
    ftUserType: function () {
      this.getUsers();
    },
  },
  computed: mapState({
    userTypes: state => state.option.options.user_types,
    hasFilters () {
      let self = this;
      return self.ftUserType != '' || self.keyword != '';
    }
  }),
  mounted () {
    this.init();
  },
  methods: {
    init () {
      let self = this;
      self.getUsers();
    },
    confDelete ( index ) {
      let self = this, item = self.users[index];
      self.$dialog
        .confirm('Are you sure you want to delete <strong>' + item.name + '</strong>?', {
          html: true,
          loader: true,
          okText: "Yes, I'm sure",
          cancelText: "Cancel",
        })
        .then(dialog => {
          ServiceUser.delete(item.id, () => {
            dialog.close();
            self.users.splice(index, 1);
            self.$notify({
              type: 'success',
              text: '<strong>' + item.name + '</strong> has been deleted'
            });
          });
        })
        .catch(() => {})
      ;
    },
    getUsers () {
      let self = this, params = {};

      if ( self.ftUserType !== '' ) {
        params.user_type_id = self.ftUserType;
      }
      if ( self.keyword !== '' ) {
        params.kw = self.keyword;
      }

      ServiceUser.getUsers(params, resp => {
        self.users = resp.data;
      });
    },
    showModalAdd ( ) {
      let self = this;
      self.$modal.show(ModalAddMember, {
      }, {
        clickToClose: false,
        width: 580
      }, {
        'member-added' ( user ) {
          self.users.push( user );
          self.$store.dispatch('GET_USERS');
        }
      });
    },
    showModalEdit (index) {
      let self = this;
      self.$modal.show(ModalEditMember, {
        user: self.users[index]
      }, {
        clickToClose: false,
        width: 580
      }, {
        'member-updated' ( user ) {
          self.users.splice( index, 1, user );
          self.$store.dispatch('GET_USERS');
        }
      });
    },
  }
}
</script>
